import {
  updateTagValue as updateTagValueMutation,
  updateEntityTag as updateEntityTagMutation,
} from "../queries/tags.graphql";
import {
  updateEntityTagWithOption,
  updateTagValueWithOption,
} from "src/pages/Designs/overlay";
import { updateTagsForEntityCache } from "../TagsEditor.util";
import { updateTagValueInCache } from "../updateTagValueInCache";
import { updateEntityTagAttributesInCache } from "../updateEntityTagAttributesInCache";
import { TAG_UPDATE_TYPE } from "../consts";
import {
  entityTagAssociationIdToPersist,
  shouldPersistNewTag,
  shouldPersistTagValue,
} from "./TagAttributesModal.save";

const persistSharedTagValue = async (ctx) => {
  if (shouldPersistNewTag(ctx.isNewTag)) {
    await ctx.setNewTag(
      {
        ...ctx.entityTag,
        displayValue: ctx.displayValue,
        attributes: ctx.updatedAttributes,
      },
      ctx.tagTypeConfig
    );
    return false;
  }
  if (
    !shouldPersistTagValue({
      isNewTag: ctx.isNewTag,
      editMode: ctx.editMode,
      entityTag: ctx.entityTag,
      updatedAttributes: ctx.updatedAttributes,
      displayValue: ctx.displayValue,
    })
  ) {
    return false;
  }
  const { data } = await ctx.overlayMutate({
    client: ctx.client,
    overlayOptionId: ctx.overlayOptionId,
    liveMutation: updateTagValueMutation,
    overlayMutation: updateTagValueWithOption,
    variables: {
      input: {
        id: ctx.entityTag.tagId,
        type: ctx.tagTypeConfig.id,
        displayValue: ctx.displayValue,
        isActive: true,
        attributes: ctx.updatedAttributes,
      },
    },
    update: (cache) => {
      updateTagValueInCache(cache, {
        tagId: ctx.entityTag.tagId,
        attributes: ctx.updatedAttributes,
        displayValue: ctx.displayValue,
        entityId: ctx.entityId,
        tagTypes: ctx.tagTypes,
        tagsQueryTagTypes: ctx.tagsQueryTagTypes,
        entityType: ctx.entityType,
      });
    },
  });
  if (ctx.onTagUpdated && data?.tag) {
    ctx.onTagUpdated({ type: TAG_UPDATE_TYPE.TAG, payload: data.tag });
  }
  return true;
};

const persistEntityTagAttrs = async (ctx, entityTagAssociationId) => {
  const result = await ctx.overlayMutate({
    client: ctx.client,
    overlayOptionId: ctx.overlayOptionId,
    liveMutation: updateEntityTagMutation,
    overlayMutation: updateEntityTagWithOption,
    variables: {
      input: {
        id: entityTagAssociationId,
        tagType: ctx.tagTypeConfig.id,
        attributes: ctx.updatedEntityTagAttributes,
        comments: {
          ...ctx.comments,
          tag: {
            tagId: ctx.entityTag.tagId,
            tagType: ctx.entityTag.type,
            displayValue: ctx.entityTag.displayValue,
          },
        },
      },
    },
    update: updateTagsForEntityCache({
      entityId: ctx.entityId,
      tagTypes: ctx.tagTypesForEntityCache,
      entityTag: ctx.entityTag,
      entityType: ctx.entityType,
    }),
  });
  if (ctx.onTagUpdated && result.data?.tag) {
    ctx.onTagUpdated({
      type: TAG_UPDATE_TYPE.ENTITY_TAG,
      payload: result.data.tag,
    });
  }
  updateEntityTagAttributesInCache(ctx.client.cache, {
    entityTagAssociationId,
    entityTagAttributes: ctx.updatedEntityTagAttributes,
    entityId: ctx.entityId,
    entityType: ctx.entityType,
    tagTypes: ctx.tagTypes,
    tagsQueryTagTypes: ctx.tagsQueryTagTypes,
  });
};

export const persistTagAttributeEdits = async (ctx) => {
  const didSaveTagValue = await persistSharedTagValue(ctx);
  const savedTagId = ctx.entityTag.tagId || ctx.entityTag.tag?.id;
  if (didSaveTagValue && savedTagId) {
    updateTagValueInCache(ctx.client.cache, {
      tagId: savedTagId,
      attributes: ctx.updatedAttributes,
      displayValue: ctx.displayValue,
      entityId: ctx.entityId,
      tagTypes: ctx.tagTypes,
      tagsQueryTagTypes: ctx.tagsQueryTagTypes,
      entityType: ctx.entityType,
    });
  }
  const entityTagAssociationId = entityTagAssociationIdToPersist(
    ctx.entityTag,
    ctx.entityTag.entityTagAttributes,
    ctx.updatedEntityTagAttributes
  );
  if (entityTagAssociationId) {
    await persistEntityTagAttrs(ctx, entityTagAssociationId);
  }
};
